import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home-dashboard" }
const _hoisted_2 = { class: "home-dashboard-header row items-center q-col-gutter-md q-mb-md" }
const _hoisted_3 = { class: "col-grow" }
const _hoisted_4 = { class: "home-dashboard-title" }
const _hoisted_5 = { class: "home-dashboard-subtitle" }
const _hoisted_6 = {
  key: 0,
  class: "home-dashboard-updated"
}
const _hoisted_7 = { class: "col-auto row items-center q-gutter-sm" }
const _hoisted_8 = { class: "row q-col-gutter-sm q-mb-md home-quick-actions" }
const _hoisted_9 = { class: "col-auto" }
const _hoisted_10 = { class: "col-auto" }
const _hoisted_11 = {
  key: 0,
  class: "home-dashboard-skeleton q-mb-md"
}
const _hoisted_12 = { class: "row q-col-gutter-md q-mb-md" }
const _hoisted_13 = { class: "row q-col-gutter-md q-mb-md" }
const _hoisted_14 = { class: "row q-col-gutter-md q-mb-md" }
const _hoisted_15 = { class: "col-lg-6 col-md-12 col-sm-12" }
const _hoisted_16 = { class: "col-lg-6 col-md-12 col-sm-12" }
const _hoisted_17 = { class: "row q-col-gutter-md q-mb-md" }
const _hoisted_18 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_19 = { class: "home-kpi-card__icon" }
const _hoisted_20 = { class: "home-kpi-card__value" }
const _hoisted_21 = {
  key: 0,
  class: "home-kpi-card__trend"
}
const _hoisted_22 = { class: "home-kpi-card__footer" }
const _hoisted_23 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_24 = { class: "home-kpi-card__icon" }
const _hoisted_25 = { class: "home-kpi-card__value" }
const _hoisted_26 = {
  key: 0,
  class: "home-kpi-card__trend"
}
const _hoisted_27 = { class: "home-kpi-card__footer" }
const _hoisted_28 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_29 = { class: "home-kpi-card__icon" }
const _hoisted_30 = { class: "home-kpi-card__value" }
const _hoisted_31 = {
  key: 0,
  class: "home-kpi-card__trend"
}
const _hoisted_32 = { class: "home-kpi-card__footer" }
const _hoisted_33 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_34 = { class: "home-kpi-card__icon" }
const _hoisted_35 = { class: "home-kpi-card__value home-kpi-card__value--amount" }
const _hoisted_36 = {
  key: 0,
  class: "home-kpi-card__trend"
}
const _hoisted_37 = { class: "home-kpi-card__footer" }
const _hoisted_38 = { class: "row q-col-gutter-md q-mb-md" }
const _hoisted_39 = { class: "col-lg-6 col-md-12 col-sm-12" }
const _hoisted_40 = { class: "home-chart-card home-chart-card--hover home-extra-kpi" }
const _hoisted_41 = { class: "home-top-clients" }
const _hoisted_42 = { class: "home-top-client-rank" }
const _hoisted_43 = { class: "home-top-client-info" }
const _hoisted_44 = { class: "home-top-client-name" }
const _hoisted_45 = { class: "home-top-client-ref" }
const _hoisted_46 = { class: "home-top-client-stats" }
const _hoisted_47 = {
  key: 0,
  class: "home-top-client-empty"
}
const _hoisted_48 = { class: "col-lg-6 col-md-12 col-sm-12" }
const _hoisted_49 = { class: "home-chart-card home-chart-card--hover home-extra-kpi home-conversion-card" }
const _hoisted_50 = { class: "home-conversion-body" }
const _hoisted_51 = { class: "home-conversion-rate" }
const _hoisted_52 = { class: "home-conversion-detail" }
const _hoisted_53 = { class: "row q-col-gutter-md q-mb-md" }
const _hoisted_54 = { class: "home-chart-card home-chart-card--hover" }
const _hoisted_55 = { class: "home-chart-card__subtitle" }
const _hoisted_56 = { class: "home-chart-card__body home-chart-card__body--split" }
const _hoisted_57 = { class: "home-chart-legend" }
const _hoisted_58 = { class: "home-chart-legend__percent" }
const _hoisted_59 = { class: "home-chart-canvas-wrap" }
const _hoisted_60 = ["data-channel"]
const _hoisted_61 = { class: "home-doughnut-center" }
const _hoisted_62 = { class: "home-chart-card home-chart-card--hover" }
const _hoisted_63 = { class: "home-chart-card__body" }
const _hoisted_64 = { ref: "financingBarChart" }
const _hoisted_65 = { class: "row q-col-gutter-md q-mb-md" }
const _hoisted_66 = { class: "col-12" }
const _hoisted_67 = { class: "home-chart-card home-chart-card--hover" }
const _hoisted_68 = { class: "home-chart-card__body" }
const _hoisted_69 = { ref: "monthlyLineChart" }
const _hoisted_70 = { class: "row q-col-gutter-md mt-4" }
const _hoisted_71 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_72 = {
  class: "home-media-link",
  href: "https://www.youtube.com/watch?v=FQI5ELFfRgU",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_73 = { class: "home-media-tile home-media-tile-video-1" }
const _hoisted_74 = { class: "home-media-overlay" }
const _hoisted_75 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_76 = {
  class: "home-media-link",
  href: "https://www.youtube.com/watch?v=CDfr4VJqGt4",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_77 = { class: "home-media-tile home-media-tile-video-2" }
const _hoisted_78 = { class: "home-media-overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_AnimatedCounter = _resolveComponent("AnimatedCounter")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "home-dashboard-page q-layout-padding pt-0" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.welcomeTitle), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.welcomeSubtitle), 1),
            (_ctx.lastUpdatedLabel)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.lastUpdatedLabel), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_q_select, {
              dense: "",
              outlined: "",
              "emit-value": "",
              "map-options": "",
              modelValue: _ctx.selectedPeriod,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPeriod) = $event)),
                _ctx.loadDashboard
              ],
              options: _ctx.periodOptions,
              class: "home-period-select"
            }, null, 8, ["modelValue", "options", "onUpdate:modelValue"]),
            _createVNode(_component_q_btn, {
              flat: "",
              round: "",
              color: "primary",
              icon: "refresh",
              loading: _ctx.isLoading,
              onClick: _ctx.loadDashboard
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("Actualiser", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_q_btn, {
              outline: "",
              color: "primary",
              icon: "assignment",
              label: "Mes tâches",
              "no-caps": "",
              class: "home-quick-btn",
              onClick: _ctx.goToTasks
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_q_btn, {
              outline: "",
              color: "primary",
              icon: "search",
              label: "Rechercher une demande",
              "no-caps": "",
              class: "home-quick-btn",
              onClick: _ctx.goToDemandSearch
            }, null, 8, ["onClick"])
          ])
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                  return _createElementVNode("div", {
                    key: 'sk-kpi-' + n,
                    class: "col-lg-3 col-md-6 col-sm-12"
                  }, [
                    _createVNode(_component_q_skeleton, {
                      height: "150px",
                      square: "",
                      class: "home-skeleton-card"
                    })
                  ])
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                  return _createElementVNode("div", {
                    key: 'sk-extra-' + n,
                    class: "col-lg-6 col-md-12 col-sm-12"
                  }, [
                    _createVNode(_component_q_skeleton, {
                      height: "220px",
                      square: "",
                      class: "home-skeleton-card"
                    })
                  ])
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_q_skeleton, {
                    height: "320px",
                    square: "",
                    class: "home-skeleton-card"
                  })
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_q_skeleton, {
                    height: "320px",
                    square: "",
                    class: "home-skeleton-card"
                  })
                ])
              ]),
              _createVNode(_component_q_skeleton, {
                height: "320px",
                square: "",
                class: "home-skeleton-card"
              })
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", {
                    class: "home-kpi-card home-kpi-card--purple home-kpi-card--clickable",
                    role: "button",
                    tabindex: "0",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToDemands({}))),
                    onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.navigateToDemands({})), ["enter"]))
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_q_icon, {
                        name: "calculate",
                        size: "28px"
                      })
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "home-kpi-card__label" }, "Simulations Financières", -1)),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_AnimatedCounter, {
                        count: _ctx.metrics.totalSimulations.total
                      }, null, 8, ["count"])
                    ]),
                    (_ctx.kpiTrends.totalSimulations !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createTextVNode(_toDisplayString(_ctx.formatTrend(_ctx.kpiTrends.totalSimulations)) + " ", 1),
                          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "home-kpi-card__trend-hint" }, "vs période précédente", -1))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTopChannelEntries(_ctx.metrics.totalSimulations.byChannel), (entry) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: 'sim-' + entry.channel
                        }, _toDisplayString(_ctx.formatChannelLabel(entry.channel)) + ": " + _toDisplayString(entry.count), 1))
                      }), 128))
                    ])
                  ], 32)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", {
                    class: "home-kpi-card home-kpi-card--pink home-kpi-card--clickable",
                    role: "button",
                    tabindex: "0",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateToDemands({ typeClientId: 'party-FrenchPerson' }))),
                    onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.navigateToDemands({ typeClientId: 'party-FrenchPerson' })), ["enter"]))
                  }, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_q_icon, {
                        name: "person",
                        size: "28px"
                      })
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "home-kpi-card__label" }, "Simulations Personnes Physiques", -1)),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_AnimatedCounter, {
                        count: _ctx.metrics.physicalPersons.total
                      }, null, 8, ["count"])
                    ]),
                    (_ctx.kpiTrends.physicalPersons !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createTextVNode(_toDisplayString(_ctx.formatTrend(_ctx.kpiTrends.physicalPersons)) + " ", 1),
                          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "home-kpi-card__trend-hint" }, "vs période précédente", -1))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_27, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTopChannelEntries(_ctx.metrics.physicalPersons.byChannel), (entry) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: 'pp-' + entry.channel
                        }, _toDisplayString(_ctx.formatChannelLabel(entry.channel)) + ": " + _toDisplayString(entry.count), 1))
                      }), 128))
                    ])
                  ], 32)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", {
                    class: "home-kpi-card home-kpi-card--cyan home-kpi-card--clickable",
                    role: "button",
                    tabindex: "0",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigateToDemands({ typeClientId: 'party-FrenchOrganization' }))),
                    onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.navigateToDemands({ typeClientId: 'party-FrenchOrganization' })), ["enter"]))
                  }, [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_q_icon, {
                        name: "business",
                        size: "28px"
                      })
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "home-kpi-card__label" }, "Simulations Personnes Morales", -1)),
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_AnimatedCounter, {
                        count: _ctx.metrics.legalEntities.total
                      }, null, 8, ["count"])
                    ]),
                    (_ctx.kpiTrends.legalEntities !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createTextVNode(_toDisplayString(_ctx.formatTrend(_ctx.kpiTrends.legalEntities)) + " ", 1),
                          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "home-kpi-card__trend-hint" }, "vs période précédente", -1))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_32, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTopChannelEntries(_ctx.metrics.legalEntities.byChannel), (entry) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: 'pm-' + entry.channel
                        }, _toDisplayString(_ctx.formatChannelLabel(entry.channel)) + ": " + _toDisplayString(entry.count), 1))
                      }), 128))
                    ])
                  ], 32)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", {
                    class: "home-kpi-card home-kpi-card--orange home-kpi-card--clickable",
                    role: "button",
                    tabindex: "0",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigateToDemands({}))),
                    onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.navigateToDemands({})), ["enter"]))
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_q_icon, {
                        name: "euro",
                        size: "28px"
                      })
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "home-kpi-card__label" }, "Montant Total", -1)),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_AnimatedCounter, {
                        count: _ctx.metrics.totalAmount.total,
                        format: "currency"
                      }, null, 8, ["count"])
                    ]),
                    (_ctx.kpiTrends.totalAmount !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createTextVNode(_toDisplayString(_ctx.formatTrend(_ctx.kpiTrends.totalAmount)) + " ", 1),
                          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "home-kpi-card__trend-hint" }, "vs période précédente", -1))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("span", null, "CN-PARC: " + _toDisplayString(_ctx.formatAmount(_ctx.metrics.totalAmount.cnParc)), 1)
                    ])
                  ], 32)
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "home-chart-card__title" }, "Top 5 Clients", -1)),
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "home-chart-card__subtitle" }, "Par nombre de simulations", -1)),
                    _createElementVNode("div", _hoisted_41, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metrics.topClients, (client, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'client-' + client.key,
                          class: "home-top-client-row"
                        }, [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(index + 1), 1),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, _toDisplayString(client.label), 1),
                            _createElementVNode("div", _hoisted_45, _toDisplayString(client.reference), 1)
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("strong", null, _toDisplayString(client.count), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatAmount(client.amount)), 1)
                          ])
                        ]))
                      }), 128)),
                      (!_ctx.metrics.topClients.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, " Aucun client sur la période "))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "home-chart-card__title" }, "Taux de Contractualisation", -1)),
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "home-chart-card__subtitle" }, " Part des demandes passées en contrat ", -1)),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_AnimatedCounter, {
                          count: _ctx.metrics.conversion.rate
                        }, null, 8, ["count"]),
                        _cache[20] || (_cache[20] = _createTextVNode("% ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.metrics.conversion.contractedCount) + " / " + _toDisplayString(_ctx.metrics.conversion.totalCount) + " demandes ", 1),
                      _createVNode(_component_q_linear_progress, {
                        value: _ctx.metrics.conversion.rate / 100,
                        color: "primary",
                        "track-color": "grey-3",
                        rounded: "",
                        size: "12px",
                        class: "q-mt-md"
                      }, null, 8, ["value"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metrics.statusByChannel, (channelData) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'channel-' + channelData.channel,
                    class: _normalizeClass(_ctx.channelChartColClass)
                  }, [
                    _createElementVNode("div", _hoisted_54, [
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "home-chart-card__title" }, "Répartition des Demandes", -1)),
                      _createElementVNode("div", _hoisted_55, _toDisplayString(channelData.channelLabel), 1),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelData.slices, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: channelData.channel + '-' + item.key,
                              class: "home-chart-legend__item"
                            }, [
                              _createElementVNode("span", {
                                class: "home-chart-legend__dot",
                                style: _normalizeStyle({ background: item.color })
                              }, null, 4),
                              _createElementVNode("span", null, _toDisplayString(item.label), 1),
                              _createElementVNode("strong", null, [
                                _createTextVNode(_toDisplayString(item.count) + " ", 1),
                                _createElementVNode("span", _hoisted_58, " (" + _toDisplayString(_ctx.getStatusPercent(item.count, channelData)) + "%) ", 1)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("canvas", {
                            class: "home-channel-chart",
                            "data-channel": channelData.channel
                          }, null, 8, _hoisted_60),
                          _createElementVNode("div", _hoisted_61, [
                            _createVNode(_component_AnimatedCounter, {
                              count: _ctx.getChannelStatusTotal(channelData)
                            }, null, 8, ["count"])
                          ])
                        ])
                      ])
                    ])
                  ], 2))
                }), 128)),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.financingChartColClass)
                }, [
                  _createElementVNode("div", _hoisted_62, [
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "home-chart-card__title" }, "Simulations par Type de Financement", -1)),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("canvas", _hoisted_64, null, 512)
                    ])
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "home-chart-card__title" }, "Évolution Mensuelle des Simulations", -1)),
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("canvas", _hoisted_69, null, 512)
                    ])
                  ])
                ])
              ])
            ], 64)),
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("a", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "home-media-title" }, "This is our vision 2030", -1)),
                  _createVNode(_component_q_btn, {
                    round: "",
                    flat: "",
                    color: "white",
                    icon: "play_arrow",
                    class: "home-media-play"
                  })
                ])
              ])
            ])
          ]),
          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col-lg-4 col-md-4 col-sm-12" }, [
            _createElementVNode("div", { class: "home-media-tile home-media-tile-social" }, [
              _createElementVNode("div", { class: "home-media-overlay home-media-overlay-center" }, [
                _createElementVNode("div", { class: "home-media-title" }, "NOS RESEAUX SOCIAUX"),
                _createElementVNode("div", { class: "home-social-icons" }, [
                  _createElementVNode("a", {
                    class: "home-social-icon home-social-instagram",
                    href: "https://www.instagram.com/teamwillgroup/",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, "IG"),
                  _createElementVNode("a", {
                    class: "home-social-icon home-social-facebook",
                    href: "https://www.facebook.com/teamwillgroup/",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, "f"),
                  _createElementVNode("a", {
                    class: "home-social-icon home-social-youtube",
                    href: "https://www.youtube.com/@TeamwillGroup",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, "YT"),
                  _createElementVNode("a", {
                    class: "home-social-icon home-social-linkedin",
                    href: "https://www.linkedin.com/company/teamwill-group/",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, "in")
                ])
              ])
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("a", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _createVNode(_component_q_btn, {
                    round: "",
                    flat: "",
                    color: "white",
                    icon: "play_arrow",
                    class: "home-media-play"
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}